import React from 'react';

import {
  Box,
  BoxProps,
} from '@waglabs/box-next';
import { Typography } from '@waglabs/typography';
import { Flex } from '@waglabs/flex-next';
import { Image } from '@waglabs/image-next';
import { Container } from '@waglabs/container';

import { Executive } from '../../../../components/Executive';
// ExecutiveUrls no longer needed; using direct LinkedIn URLs per request

import adamStormImg from '../../../../assets/executives/adam-storm.png';
import alecDavidianImg from '../../../../assets/executives/alec-davidian.png';
import garrettSmallwoodImg from '../../../../assets/executives/garrett-smallwood.png';
import pawBg from '../../../../assets/paws-bg.svg';

const leadershipMembers = [
  {
    img: garrettSmallwoodImg,
    name: 'Garrett Smallwood',
    position: 'CEO',
    href: 'https://www.linkedin.com/in/garrettsmallwood',
  },
  {
    img: adamStormImg,
    name: 'Adam Storm',
    position: 'President & Chief Product Officer',
    href: 'https://www.linkedin.com/in/adamstorm',
  },
  {
    img: alecDavidianImg,
    name: 'Alec Davidian',
    position: 'Chief Financial Officer',
    href: 'https://www.linkedin.com/in/alecdavidian',
  },
] as const;

export type ExecutiveSectionProps = BoxProps;
export const ExecutiveSection = (props: ExecutiveSectionProps) => (
  <Box
    id="team"
    position="relative"
    mb={['80px', '40px']}
    {...props}
  >
    <Container
      position="relative"
      zIndex={1}
    >
      <Typography
        variant="h2"
        color="#474747"
        textAlign="center"
        maxWidth="1000px"
        mx="auto"
        my={['40px', '24px']}
      >
        {'Wag! is designed and backed by the world\'s leading marketplace experts'}
      </Typography>
      <Box
        pt={3}
      >
        <Typography
          variant="h3"
          color="wagBlue"
          m={0}
          textAlign="center"
          textTransform="uppercase"
        >
          Leadership
        </Typography>
        <Flex
          justifyContent={['unset', 'center']}
          flexWrap="wrap"
          m="0 auto"
          mt={[4, null, 0]}
          px={[0, '24px', '24px', '54px']}
        >
          {leadershipMembers.map((leader, index) => (
            <Executive
              alt={leader.name}
              href={leader.href}
              index={index}
              key={leader.name}
              name={leader.name}
              src={leader.img}
              position={leader.position}
            />
          ))}
        </Flex>
      </Box>
    </Container>
    <Image
      src={pawBg}
      width="504px"
      alt="paw background"
      display={['none', 'block']}
      position="absolute"
      zIndex={0}
      pointerEvents="none"
      left="-200px"
      bottom={0}
    />
  </Box>
);
